import { IDeclarationTemplate } from '../types';
import { useHydraMutation, HydraMutationParams } from './useHydraMutation';

export function useCreateDeclarationTemplateMutation<D extends IDeclarationTemplate>(
  params?: HydraMutationParams
) {
  return useHydraMutation('api/declaration_templates', params);
}
